export function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export function createSlug(str) {
  let slug = str.toLowerCase();
  slug = slug.replace(/[^\w\s-]/g, '');
  slug = slug.replace(/[\s_]+/g, '-');
  slug = slug.replace(/^-+|-+$/g, '');
  return slug;
}

export function detectPassiveVoice(text) {
  const results = [];
  const regex = /\b(?:was|were)\s+\w+ed\b/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    results.push({
      start: match.index,
      end: match.index + match[0].length,
      message: "Passive voice",
    });
  }
  return results;
}

export function detectLongSentences(text, wordLimit = 20) {
  const results = [];
  let charIndex = 0;

  const sentenceRegex = /[^.!?]+[.!?]+[\])'"`’”]*\s*/g;
  const sentences = text.match(sentenceRegex) || [];

  console.log("Sentences:", sentences);

  for (const sentence of sentences) {
    const trimmed = sentence.trim();
    const wordCount = trimmed.split(/\s+/).length;

    if (wordCount > wordLimit) {
      console.log("Long sentence found:", sentence);
      results.push({
        start: charIndex,
        end: charIndex + sentence.length,
        message: "Long sentence",
      });
    }

    charIndex += sentence.length;
  }

  return results;
}
